import {
  PANEL_COLOR_VALUES,
  type ActivePanelTypes,
} from "@/components/layout/split-screen/split-screen.constants";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export const SPLIT_SCREEN_SLIC_NAME = "split_screen";

export interface ISplitScreenSlice {
  isSplitScreenAvailable: boolean;
  showSplitScreen: boolean;
  highlightColor: string;
  isModulePickerOpen: boolean;
  isSplitScreenClosed: boolean;
  splitPath: string | null;
  activePanel: ActivePanelTypes;
}

export const initialState: ISplitScreenSlice = {
  isSplitScreenAvailable: true,
  showSplitScreen: false,
  highlightColor: PANEL_COLOR_VALUES[0],
  isModulePickerOpen: false,
  isSplitScreenClosed: false,
  splitPath: null,
  activePanel: "bottom",
};

const splitScreenSlice = createSlice({
  name: SPLIT_SCREEN_SLIC_NAME,
  initialState,
  reducers: {
    setSplitPath: (state, action: PayloadAction<string | null>) => {
      state.splitPath = action.payload;
    },
    toggleSplitScreen: (state) => {
      state.showSplitScreen = !state.showSplitScreen;
    },
    startSplitScreen: (state, action: PayloadAction<string | undefined>) => {
      state.showSplitScreen = true;
      state.splitPath = action.payload ?? null;
    },
    toggleSplitModulePicker: (state) => {
      state.isModulePickerOpen = !state.isModulePickerOpen;
    },
    setHighlightColor: (state, action: PayloadAction<string>) => {
      state.highlightColor = action.payload;
    },
    setIsSplitScreenOpen: (state, action: PayloadAction<boolean>) => {
      state.isSplitScreenClosed = action.payload;
    },
    setActivePanel: (state, action: PayloadAction<ActivePanelTypes>) => {
      state.activePanel = action.payload;
    },
    setIsSplitScreenAvailable: (state, action: PayloadAction<boolean>) => {
      state.isSplitScreenAvailable = action.payload;
    },
    stopSplitScreen: () => initialState,
  },
});

export const {
  setSplitPath,
  setActivePanel,
  stopSplitScreen,
  startSplitScreen,
  setHighlightColor,
  toggleSplitScreen,
  setIsSplitScreenOpen,
  toggleSplitModulePicker,
  setIsSplitScreenAvailable,
} = splitScreenSlice.actions;

export const selectSplitScreenSlice = (state: {
  [SPLIT_SCREEN_SLIC_NAME]: ISplitScreenSlice;
}) => state[SPLIT_SCREEN_SLIC_NAME];

export default splitScreenSlice.reducer;
